<template>
    <UtilPanelContent>
        <template v-slot:utils>
            <div v-if="stShowSettings">
                <Settings
                    :isChallengeFunctionality="true"
                    @close-settings="showSettings"
                    class="elevation-11 border-radius-1 utils-box"
                />
            </div>
            <div v-show="stShowQuestions">
                <Questions @close-question="openQuestion" class="elevation-11 border-radius-1 utils-box" />
            </div>
            <div v-if="stShowMusic">
                <Music
                    :isChallengeFunctionality="true"
                    @close-music="showMusic"
                    class="elevation-11 border-radius-1 utils-box"
                />
            </div>
            <div v-if="stShowDictionary">
                <Dictionary
                    @close-dictionary="openDictionary"
                    v-if="stShowDictionary"
                    class="elevation-11 border-radius-1 utils-box"
                />
            </div>
            <div v-show="stShowReadaloud" transition="slide-x-transition">
                <ReadAloud @close-reading="showReadaloud" class="elevation-11 border-radius-1 utils-box" />
            </div>
        </template>
        <div
            :class="
                'mx-auto border-radius-1 transition-all util-bar d-none d-md-block ' +
                (showTexts ? 'util-bar-text' : 'util-bar-non-text')
            "
        >
            <div
                class="d-flex flex-column justify-center align-center util-bar-border content-shadow w-100"
                @mouseover="!isMobile && (showTexts = true)"
                @mouseleave="!isMobile && (showTexts = false)"
                @touchstart="isMobile && (showTexts = true)"
                @touchend="handleTouchEnd"
            >
                <div class="border-top w-100">
                    <v-btn
                        data-cy="utilsPanels-settings-button"
                        text
                        block
                        class="w-100 ma-0 py-6 d-flex justify-end align-center utils-panel-button"
                        @click="
                            closeQuestion()
                            showSettings()
                        "
                        ><div
                            class="d-flex flex-column justify-center align-end option--primary ml-15 mr-2"
                            v-if="showTexts"
                        >
                            <span class="text-capitalize">{{ texts.settingTxt.text }} </span>
                            <span class="font-size-9 font-weight-regular opacity-9 text-capitalize"
                                >{{ texts.settingTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="settingImg"
                    /></v-btn>
                </div>
                <div class="bottom-radius border-bottom w-100">
                    <v-btn
                        data-cy="utilsPanels-dictionary-button"
                        block
                        color="transparent"
                        elevation="0"
                        class="w-100 ma-0 border-radius-0 py-6 d-flex justify-end align-center utils-panel-button"
                        @click="
                            closeQuestion()
                            openDictionary()
                        "
                        ><div
                            class="d-flex flex-column justify-center align-end option--white ml-15 mr-2"
                            v-if="showTexts"
                        >
                            <span class="text-capitalize">{{ texts.dictionaryTxt.text }} </span>
                            <span class="font-size-9 font-weight-regular opacity-9 text-capitalize"
                                >{{ texts.dictionaryTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="dictionaryImg"
                    /></v-btn>
                    <v-btn
                        data-cy="utilsPanels-narrator-button"
                        block
                        color="transparent"
                        elevation="0"
                        class="w-100 ma-0 border-radius-0 py-6 d-flex justify-end align-center utils-panel-button"
                        @click="
                            showReadaloud()
                            closeQuestion()
                        "
                        ><div
                            class="d-flex flex-column justify-center align-end option--white ml-15 mr-2"
                            v-if="showTexts"
                        >
                            <span class="text-capitalize">{{ texts.readaloudTxt.text }} </span>
                            <span class="font-size-9 font-weight-regular opacity-9 text-capitalize"
                                >{{ texts.readaloudTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="readaloudImg"
                    /></v-btn>
                    <v-btn
                        data-cy="utilsPanels-music-button"
                        block
                        color="transparent"
                        elevation="0"
                        class="w-100 ma-0 border-radius-0 py-6 d-flex justify-end align-center utils-panel-button"
                        @click="
                            closeQuestion()
                            showMusic()
                        "
                        ><div
                            class="d-flex flex-column justify-center align-end option--white ml-15 mr-2"
                            v-if="showTexts"
                        >
                            <span class="text-capitalize">{{ texts.musicTxt.text }} </span>
                            <span class="font-size-9 font-weight-regular opacity-9 text-capitalize"
                                >{{ texts.musicTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="musicImg"
                    /></v-btn>
                </div>
            </div>
        </div>
    </UtilPanelContent>
</template>
<script>
/* eslint-disable global-require */
import { mapActions, mapState } from 'vuex'

import Music from '@/components/core/utils/Music.vue'
import UtilPanelContent from '@/components/core/utils/UtilPanelContent.vue'
import Dictionary from '@/components/core/utils/Dictionary.vue'
import ReadAloud from '@/components/core/utils/ReadAloud.vue'
import Settings from '@/components/core/utils/Settings.vue'
import Questions from './challengeUtils/Question.vue'

export default {
    components: {
        Settings,
        Questions,
        Music,
        Dictionary,
        ReadAloud,
        UtilPanelContent,
    },
    data() {
        return {
            showTexts: false,
            indexImg: require('@/assets/img/icons/new-reading/index-purple.svg'),
            settingImg: require('@/assets/img/icons/new-reading/settings-purple.svg'),
            questionsImg: require('@/assets/img/icons/reading/3-questions.svg'),
            highlightingsImg: require('@/assets/img/icons/new-reading/highlighting-white.svg'),
            notesImg: require('@/assets/img/icons/new-reading/notes-white.svg'),
            dictionaryImg: require('@/assets/img/icons/new-reading/dictionary-white.svg'),
            readaloudImg: require('@/assets/img/icons/new-reading/read-aloud-white.svg'),
            musicImg: require('@/assets/img/icons/new-reading/music-white.svg'),
        }
    },
    methods: {
        ...mapActions('bookReading', [
            'showSettings',
            'showMusic',
            'showDictionary',
            'setDictionaryMode',
            'showReadaloud',
            'hideAllUtils',
        ]),
        ...mapActions('challenge', ['ShowQuestion', 'setReadingTime', 'setReReadingTime', 'startReading', 'pauseReading']),
        openDictionary() {
            this.setDictionaryMode('manual')
            this.showDictionary()
        },
        openQuestion() {
            this.hideAllUtils()
            this.ShowQuestion()
            if (this.stShowQuestions) {
                this.pauseReading()
                if (this.tiempoEmpleadoReLectura !== 0) {
                    this.pauseReReading()
                }
            } else {
                this.startReading()
                if (this.tiempoEmpleadoReLectura !== 0) {
                    this.startReReading()
                }
            }
        },
        closeQuestion() {
            if (this.stShowQuestions) this.ShowQuestion()
        },
        handleTouchEnd() {
            if (this.isMobile) {
                setTimeout(() => {
                    this.showTexts = false;
                }, 2000);
            }
        },
    },
    computed: {
        ...mapState({
            stShowIndex: (state) => state.bookReading.showIndex,
            stShowSettings: (state) => state.bookReading.showSettings,
            stShowQuestions: (state) => state.challenge.showQuestion,
            stShowHighlights: (state) => state.bookReading.showHighlights,
            stShowMusic: (state) => state.bookReading.showMusic,
            stShowDictionary: (state) => state.bookReading.showDictionary,
            stShowNotes: (state) => state.bookReading.showNotes,
            stShowReadaloud: (state) => state.bookReading.showReadaloud,
            hasQuestion: (state) => state.bookReading.hasQuestion,
            tiempoEmpleadoLectura: (state) => state.challenge.tiempoEmpleadoLectura,
            tiempoEmpleadoReLectura: (state) => state.challenge.tiempoEmpleadoReLectura,
        }),
        isMobile() {
            return window.innerWidth <= 600;
        },
        texts() {
            return {
                indexTxt: {
                    text: this.$t('bookReading.index'),
                    trl: this.$i18n.locale === 'es' ? 'Index' : 'Índice',
                },
                settingTxt: {
                    text: this.$t('bookReading.settings'),
                    trl: this.$i18n.locale === 'es' ? 'Settings' : 'Ajustes',
                },
                questionsTxt: {
                    text: this.$t('bookReading.question'),
                    trl: this.$i18n.locale === 'es' ? 'Questions' : 'Preguntas',
                },
                highlightingsTxt: {
                    text: this.$t('bookReading.marker'),
                    trl: this.$i18n.locale === 'es' ? 'Highlighting' : 'Marcadores',
                },
                notesTxt: {
                    text: this.$t('bookReading.notes'),
                    trl: this.$i18n.locale === 'es' ? 'Notes' : 'Notas',
                },
                dictionaryTxt: {
                    text: this.$t('bookReading.dictionary'),
                    trl: this.$i18n.locale === 'es' ? 'Dictionary' : 'Diccionario',
                },
                readaloudTxt: {
                    text: this.$t('bookReading.storyletter'),
                    trl: this.$i18n.locale === 'es' ? 'Read Aloud' : 'Narrador',
                },
                musicTxt: {
                    text: this.$t('bookReading.music'),
                    trl: this.$i18n.locale === 'es' ? 'Music' : 'Música',
                },
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.bg-purple {
    background: #514585;
    border: 1.5px solid #514585;
}
.option--primary {
    color: #514585;
}
.option--white {
    color: white;
}
.util-bar {
    z-index: 5;
    position: fixed;
}

.util-bar-text {
    width: 12.5em !important;
}

.util-bar-non-text {
    width: 3.5em;
}
.util-bar-border {
    border-radius: 1vh;
}

.bottom-radius {
    border-radius: 0 0 1vh 1vh !important;
}

.border-top {
    border: 1.5px solid #514585 !important;
    border-radius: 1vh 1vh 0 0 !important;
    background: white;
}
.border-bottom {
    border: 1.5px solid #514585 !important;
    background: #514585;
}

.content-shadow {
    box-shadow: 0 6px 7px -4px rgba(0, 0, 0, 0.2), 0 11px 15px 1px rgba(0, 0, 0, 0.14),
        0 4px 20px 3px rgba(0, 0, 0, 0.12) !important;
}

.reading-util-icon {
    height: 32px;
    width: 32px;
}

.util-bar {
    right: 1em;
    top: 1rem;
}

/* Optimizaciones para móvil */
@media screen and (max-width: 600px) {
    .util-bar {
        position: relative!important;
        right: auto!important;
        top: auto!important;
        align-items: center!important;
        justify-content: space-around!important;
        min-height: 60px!important;
    }
    
    .util-bar-border {
        border-radius: 30px!important;
        overflow: hidden!important;
    }
    
    .border-top,
    .border-bottom {
        flex: 1!important;
        margin: 0!important;
    }
    
    .utils-panel-button {
        min-width: 44px!important;
        min-height: 44px!important;
        border-radius: 50%!important;
        margin: 0 2px!important;
    }
    
    .reading-util-icon {
        margin: 0!important;
    }
    
    /* Hacer el panel más compacto */
    .util-bar-text {
        width: auto!important;
        min-width: 200px!important;
    }
    
    .util-bar-non-text {
        width: auto!important;
        min-width: 200px!important;
    }
}

.v-btn.utils-panel-button{
    padding: 0 10px;
}
.utils-box{
    box-shadow: 0 0 0 !important;
}
</style>
